import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import {
    Typography
} from '@mui/material';
import { Form, Button, Pill } from 'Components';
import TagsManage from 'Modules/.common/components/TagsManage';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { NotificationManager } from 'Components/Notifications';

import './styles.scss';

//actions
import {
    clearRedux,
    accountTagsOpenCloseDeleteTagsModal,
    accountTagsDeleteTags
} from 'Redux/actions';

const DeleteTags = (props) => {
    const dispatch = useDispatch();
    const { callback } = props;
    const { messages } = useIntl();

    const deleteTagsForm = useRef();

    const open = useSelector(state => state.deleteTagsRedux.open);
    const items = useSelector(state => state.deleteTagsRedux.selected);
    const response = useSelector(state => state.deleteTagsRedux.response);
    const loading = useSelector(state => state.deleteTagsRedux.loading);

    const [formData, setFormData] = useState({});
    const [errorMessage, setErrorMessage] = useState(null);

    let moveEntities = false;
    moveEntities = items?.find(item => item?.unitsCount || item?.driversCount || item?.landmarksCount || item?.usersCount || item?.assetsCount || item?.geofencesCount || item?.hasChildren);

    useEffect(() => {
        return () => {
            dispatch(clearRedux("ACCOUNT_TAGS_DELETE_TAGS"));
            setFormData({});
        }
    }, []);

    useEffect(() => {
        if (response && open) {
            if (response.error) {
                const errorMessage = response.errorMessage?.includes("CompanyReadonly") ? response.errorMessage : messages['errorMessage'];
                NotificationManager.error(
                    errorMessage,
                    messages['error'],
                    3000,
                    null,
                    null,
                    'warning',
                );
            } else {
                NotificationManager.success(
                    messages['accountTagsDeleteTags_deleted'],
                    messages['success'],
                    3000,
                    null,
                    null,
                    'success',
                );
                callback();
                handleClose();
            }
        }
    }, [response, open]);

    const onSubmit = useCallback(() => {
        setErrorMessage(null);

        if (!formData.tag && moveEntities) {
            setErrorMessage(messages['required_field']);
            return;
        }
        dispatch(accountTagsDeleteTags({
            tagId: formData?.tag?.id || 0,
            tagIdsToDelete: items?.map(item => item?.id)
        }));
    });

    const handleClose = useCallback(() => {
        dispatch(accountTagsOpenCloseDeleteTagsModal(false));
        dispatch(clearRedux("ACCOUNT_TAGS_DELETE_TAGS"));
        setFormData({});
    });

    return (
        <Modal
            title={messages['accountTagsDeleteTags_title']}
            open={open}
            position="right"
            size="small"
            style={{ overflow: 'hidden' }}
            className="overflow-hidden"
            handleClose={handleClose}
        >
            <ModalBody
                style={{
                    overflow: 'hidden',
                    marginBottom: 0
                }}
            >
                <div
                    style={{
                        padding: 24,
                        height: "calc(100vh - 225px)",
                        overflowX: 'auto'
                    }}
                >
                    <Form ref={deleteTagsForm} onValidSubmit={onSubmit}>
                        <Typography
                            variant="subtitle2"
                            color="textSecondary"
                        >
                            {messages['accountTagsDeleteTags_deleteWarning']}
                        </Typography>

                        {
                            (items && items?.length) &&
                            <ul className='delete-tags-list'>
                                {
                                    items.map((item, key) => {
                                        return (
                                            <li key={key}>
                                                <Pill
                                                    textField="label"
                                                    item={item}
                                                    outlined={false}
                                                />
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        }


                        {
                            moveEntities &&
                            <React.Fragment>
                                <Typography
                                    variant="subtitle2"
                                    color="textSecondary"
                                >
                                    {messages['accountTagsDeleteTags_selectTag']}
                                </Typography>

                                <div style={{ width: '100%', marginTop: 10 }}>
                                    <TagsManage
                                        value={formData?.tag ? [formData?.tag] : []}
                                        multiple={false}
                                        onlyTags={true}
                                        disableUntaggedSelection={true}
                                        onChange={(value) => {
                                            let tagIds = items.map(item => item?.id);
                                            if (tagIds?.includes(value[0]?.id)) {
                                                setFormData({ ...formData, tag: null });
                                                setErrorMessage(messages['accountTagsDeleteTags_errorSelectTag']);
                                                return;
                                            }

                                            setErrorMessage(null);
                                            setFormData({ ...formData, tag: value[0] });
                                        }}
                                    />

                                    {
                                        errorMessage &&
                                        <small className='text-danger'>{errorMessage}</small>
                                    }
                                </div>
                            </React.Fragment>
                        }
                    </Form>
                </div>
            </ModalBody>

            <ModalFooter style={{ boxShadow: "2px 2px 2px 1px rgb(2 0 0 / 94%)" }}>
                <Button
                    disabled={loading}
                    onClick={handleClose}
                    className="btn-cancel"
                >
                    {messages['cancel']}
                </Button>

                <Button
                    disabled={loading}
                    onClick={(e) => {
                        if (e) e.preventDefault();
                        deleteTagsForm.current.submit();
                    }}
                    className="btn-red"
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    );
}

export default DeleteTags;